var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalPedAmber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37.201mm",
    height: "63.868mm",
    viewBox: "0 0 37.201 63.868",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.149 -78.374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 67.149 79.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4.2676,
    width: 140.6,
    height: 241.39,
    ry: 44.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.301,
    cy: 60.73,
    r: 44.596,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.301,
    cy: 172.13,
    r: 44.596,
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalPedAmber);
export default __webpack_public_path__ + "static/media/signal_ped_amber.70cc4e5d5d8c8897db385a8bfdb56dfe.svg";
export { ForwardRef as ReactComponent };